import { render } from "./5-FeaturesInfo.vue?vue&type=template&id=3920d1d6"
import script from "./5-FeaturesInfo.vue?vue&type=script&lang=js"
export * from "./5-FeaturesInfo.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./5-FeaturesInfo.vue?vue&type=style&index=0&id=3920d1d6&lang=less&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__